








import Vue from 'vue';

export default Vue.extend({

  name: 'DisplayMindMap',

  props: {
    nbNodes: { type: Number, default: 0 },
    height: { type: Number, default: 50 }
  }
});

